export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  AUTH_DIAG_ENVIRONMENT: "CHINA_EU_STAGE",
  apiGateway: {
    REGION: "eu-west-1",
    URL: "https://q9v17ce6pe.execute-api.eu-west-1.amazonaws.com/dev",
  },
  cognito: {
    REGION: "eu-west-1",
    USER_POOL_ID: "eu-west-1_WeIMQeEOY",
    APP_CLIENT_ID: "7s0nvfa07luumgv32fj0g22if4",
    APP_CLIENT_SECRET: "17gmhfjl99nhctu9113bk229dl8569m7noqtlmumo5mmc0qveqig",
    DOMAIN: "https://eu-west-1weimqeeoy.auth.eu-west-1.amazoncognito.com",
    IDENTITY_POOL_ID: "eu-west-1:96bae4cf-381d-45e2-a484-fbafe0f1f6f4"
  }
};
